import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_ReportService } from './Utilities.report.index';
import { Totes_ReportService } from './Totes.report.index';


@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_ReportService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_ReportService);
    this.Totes = this.injector.get(Totes_ReportService);
  }
    public Utilities: Utilities_ReportService;
    public Totes: Totes_ReportService;

  public ProgrammableLogicController: ProgrammableLogicController_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

